// © 2025 Camp Promethean, LLC. All Rights Reserved.

export function ShotSizeCalculatorTooltipContent() {
  return (
    <div className="space-y-2.5 text-xs leading-relaxed">
      <p className="text-sm font-medium">Shot Size Calculator</p>
      <p>
        Converts substrate volume, emitter flow rate (GPH), and emitter count into drip shot
        volumes and run times for each target saturation level (% VWC).
      </p>
      <div>
        <p className="font-medium">How to use</p>
        <ol className="mt-1 list-decimal space-y-0.5 pl-4">
          <li>Select a substrate preset or add a custom container volume (mL).</li>
          <li>Enter emitter flow rate (GPH) and emitters per plant.</li>
          <li>Click Calculate to generate results from 0.5–15% VWC in 0.5% steps.</li>
        </ol>
      </div>
      <div>
        <p className="font-medium">Each result shows</p>
        <ul className="mt-1 list-disc space-y-0.5 pl-4">
          <li>Volume (mL) delivered per shot</li>
          <li>Duration (seconds) to run at your flow rate</li>
        </ul>
      </div>
      <p className="text-muted-foreground">
        Use this to dial in resaturation and maintenance shots, compare emitter setups, and save
        profiles for recurring room configurations.
      </p>
    </div>
  );
}
